﻿import styled from 'styled-components';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

export const ListingWrapper = styled.div`
    position: relative; 
    margin-bottom: 40px;
    border-radius: 5px;
    overflow: hidden;

    ${mediaQuery.small(`
        margin-top: 20px;
        margin-bottom: 0px;
    `)};
`;

export const Header = styled.div`
    background-color: white; 
    color: black; 
    padding: 30px;
    ${mediaQuery.large(`
        padding: 20px;
    `)};

    font-family: ${definitions.fonts.main};
    font-size: 18px; 
    ${mediaQuery.large(`
        font-size: 16px;
    `)}
`;

export const StatusCtaWrapper = styled.div`
    position: relative;
    height: auto; 
    padding: 35px;
    ${mediaQuery.xxsmall(`
        padding: 20px;
    `)};

    color: white; 
    border: 1px solid rgba(255, 255, 255, 0.3);

    ${clearFix()}
`;

export const StatusBlockColumn = styled.div` 
    float: left; 
    width: 50%;
    text-align: ${props => props.align ? props.align : 'left'};

    ${props => mediaQuery.xsmall(`
        float: none; 
        width: 100%;
        display: block;

        &:not(:first-of-type) {
            margin-top: 20px;
        }

        text-align: ${props.align == 'right' ? 'center' : 'left'};
    `)}

`;
